<script setup>
import { computed, ref, inject } from 'vue';
import { Swiper, SwiperSlide} from 'swiper/vue';
import { Pagination } from 'swiper/modules';
import { useWindowSize } from '@vueuse/core';
const { width } = useWindowSize();
import 'swiper/css';
import 'swiper/css/pagination';
const modules = [Pagination];
const DLEvent = inject('DLEvent');
const items = [
  {id: 'small', title: 'малые породы', weight: 'до 10 кг', age: 'до 12 мес.', characteristics: [
    'Высокая скорость обмена веществ',
    'Быстрый рост и&nbsp;раннее взросление',
    'Малый объём желудка',
    'Высокий уровень активности',
    'Имеют бóльшую безжировую массу тела по&nbsp;сравнению со&nbsp;средними и&nbsp;крупными породами'
  ]},
  {id: 'medium', title: 'средние породы', weight: '10–25 кг', age: 'до 18 мес.', characteristics: [
    'Умеренная скорость обмена веществ',
    'Сбалансированный темп роста',
    'Умеренная физическая активность'
  ]},
  {id: 'big', title: 'крупные породы', weight: 'более 25 кг', age: 'до 24 мес.', characteristics: [
    'Быстрый и&nbsp;продолжительный рост',
    'Позднее завершение формирования организма',
    'Высокая нагрузка на&nbsp;опорно-двигательный аппарат',
    'Более медленный обмен веществ по&nbsp;сравнению с&nbsp;мелкими породами',
    'Относительно большой объём желудка'
  ]},
]
const flippedId = ref(null);
const toggleFlip = (id, title) => {
  flippedId.value = flippedId.value === id ? null : id;
  DLEvent('puppyPage_size_click', 'puppy_size', title);
};

const swiperOptions = computed(() => {
  return {
    modules: modules,
    slidesPerView: 'auto',
    spaceBetween: 16,
    centerInsufficientSlides: true,
    pagination: {
      clickable: true,
    }
  }
})
</script>
<template>
  <div class="info-cards">
    <div class="info-cards__inner">
      <h2 class="info-cards__title">Период взросления щенка зависит от&nbsp;его размера</h2>
      <p class="info-cards__subtitle">Это важно учитывать в&nbsp;кормлении</p>
      <div class="info-cards__items" v-if="width > 1023">
        <div
            v-for="item in items"
            :key="item.id"
            :class="['info-cards__item', { _flip: flippedId === item.id }]"
            @click="toggleFlip(item.id, item.title)"
        >
          <div class="info-cards__item-inner">
            <div class="info-cards__item-front">
              <div class="info-cards__item-icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g opacity="0.48" clip-path="url(#clip0_588_387)">
                    <circle cx="16" cy="16" r="15" stroke="#D9D9D9" stroke-width="2"/>
                    <path d="M17.5456 13.5344V23.3169H14.8768V13.5344H17.5456ZM16.2156 9.7019C16.6122 9.7019 16.9535 9.79524 17.2393 9.9819C17.5251 10.1627 17.6681 10.504 17.6681 11.0057C17.6681 11.5015 17.5251 11.8457 17.2393 12.0382C16.9535 12.2248 16.6122 12.3182 16.2156 12.3182C15.8131 12.3182 15.4689 12.2248 15.1831 12.0382C14.9031 11.8457 14.7631 11.5015 14.7631 11.0057C14.7631 10.504 14.9031 10.1627 15.1831 9.9819C15.4689 9.79524 15.8131 9.7019 16.2156 9.7019Z" fill="white"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_588_387">
                      <rect width="32" height="32" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <img :src="require(`@/assets/img/dog-${item.id}.png`)" alt="" />
              <h3>{{ item.title }}</h3>
              <div class="info-cards__item-info" @click.stop>
                <div>
                  <span class="_title">Вес</span>
                  <span class="_value">
                    {{ item.weight }}
                    <span class="info-cards__item-tip" @click.stop>
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle opacity="0.8" cx="9" cy="9" r="8.5" stroke="#D9D9D9"/>
                        <path opacity="0.8" d="M9.86942 7.61318V13.1158H8.36824V7.61318H9.86942ZM9.12129 5.4574C9.34442 5.4574 9.53637 5.5099 9.69715 5.6149C9.85793 5.71662 9.93832 5.90857 9.93832 6.19076C9.93832 6.46966 9.85793 6.66326 9.69715 6.77154C9.53637 6.87654 9.34442 6.92904 9.12129 6.92904C8.89489 6.92904 8.70129 6.87654 8.54051 6.77154C8.38301 6.66326 8.30426 6.46966 8.30426 6.19076C8.30426 5.90857 8.38301 5.71662 8.54051 5.6149C8.70129 5.5099 8.89489 5.4574 9.12129 5.4574Z" fill="white"/>
                      </svg>
                      <span>Вес щенка во взрослом возрасте</span>
                    </span>
                  </span>
                </div>
                <div>
                  <span class="_title">Взросление</span>
                  <span>{{ item.age }}</span>
                </div>
              </div>
            </div>
            <div class="info-cards__item-back">
              <h3>Физиологические особенности</h3>
              <ul>
                <li v-for="listItem in item.characteristics" :key="listItem" v-html="listItem"></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Swiper
          v-else
          v-bind="swiperOptions"
          class="info-cards__slider"
      >
        <SwiperSlide v-for="item in items" :key="item.id">
          <div :class="['info-cards__item', { _flip: flippedId === item.id }]" @click="toggleFlip(item.id, item.title)">
            <div class="info-cards__item-inner">
              <div class="info-cards__item-front">
                <div class="info-cards__item-icon">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g opacity="0.48" clip-path="url(#clip0_588_387)">
                      <circle cx="16" cy="16" r="15" stroke="#D9D9D9" stroke-width="2"/>
                      <path d="M17.5456 13.5344V23.3169H14.8768V13.5344H17.5456ZM16.2156 9.7019C16.6122 9.7019 16.9535 9.79524 17.2393 9.9819C17.5251 10.1627 17.6681 10.504 17.6681 11.0057C17.6681 11.5015 17.5251 11.8457 17.2393 12.0382C16.9535 12.2248 16.6122 12.3182 16.2156 12.3182C15.8131 12.3182 15.4689 12.2248 15.1831 12.0382C14.9031 11.8457 14.7631 11.5015 14.7631 11.0057C14.7631 10.504 14.9031 10.1627 15.1831 9.9819C15.4689 9.79524 15.8131 9.7019 16.2156 9.7019Z" fill="white"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_588_387">
                        <rect width="32" height="32" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <img :src="require(`@/assets/img/dog-${item.id}.png`)" alt="" />
                <h3>{{ item.title }}</h3>
                <div class="info-cards__item-info" @click.stop>
                  <div>
                    <span class="_title">Вес</span>
                    <span class="_value">
                      {{ item.weight }}
                      <span class="info-cards__item-tip">
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle opacity="0.8" cx="9" cy="9" r="8.5" stroke="#D9D9D9"/>
                        <path opacity="0.8" d="M9.86942 7.61318V13.1158H8.36824V7.61318H9.86942ZM9.12129 5.4574C9.34442 5.4574 9.53637 5.5099 9.69715 5.6149C9.85793 5.71662 9.93832 5.90857 9.93832 6.19076C9.93832 6.46966 9.85793 6.66326 9.69715 6.77154C9.53637 6.87654 9.34442 6.92904 9.12129 6.92904C8.89489 6.92904 8.70129 6.87654 8.54051 6.77154C8.38301 6.66326 8.30426 6.46966 8.30426 6.19076C8.30426 5.90857 8.38301 5.71662 8.54051 5.6149C8.70129 5.5099 8.89489 5.4574 9.12129 5.4574Z" fill="white"/>
                      </svg>
                      <span>Вес щенка во взрослом возрасте</span>
                    </span>
                    </span>
                  </div>
                  <div>
                    <span class="_title">Взросление</span>
                    <span>{{ item.age }}</span>
                  </div>
                </div>
              </div>
              <div class="info-cards__item-back">
                <h3>Физиологические особенности</h3>
                <ul>
                  <li v-for="listItem in item.characteristics" :key="listItem" v-html="listItem"></li>
                </ul>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <template #pagination></template>
      </Swiper>
      <div class="info-cards__note">
        <div>
          <img src="@/assets/img/icon-alert.svg" alt="" />
          <p>Питание в&nbsp;период роста должно соответствовать темпам развития щенка, обеспечивая его оптимальным балансом энергии и&nbsp;питательных веществ на&nbsp;каждом этапе взросления</p>
        </div>
      </div>
    </div>
  </div>
</template>